<div class="divi-btn" mat-ripple>
    <mat-icon>play_arrow</mat-icon>
    <ng-content></ng-content>
</div>